import { HeroHeader } from '@/components/chakraUIPro/hero-header';
import { Button } from '@/components/ui/button';
import CircleAsset from '@/components/LandingPage/CircleAsset';
import DotGridAsset from '@/components/LandingPage/DotGridAsset';
import { Badge, Box, Container, Icon, Image, SimpleGrid, Stack } from '@chakra-ui/react';
import { FaRegLightbulb } from 'react-icons/fa';
import { motion } from 'framer-motion';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';

export const HeroMain = () => {
  const { t } = useTranslation('landing');
  return (
    <Container mx='auto' pt={{ base: 0, md: 8, lg: 0 }}>
      <SimpleGrid columns={{ base: 1, lg: 2 }} gap={{ base: '12', md: '16' }}>
        <HeroHeader
          tagline={
            <Badge
              size={{ base: 'md', md: 'lg' }}
              colorPalette='gray'
              display={{ base: 'none', md: 'inline-flex' }}
              alignItems='center'
              maxW='full'
              whiteSpace='normal'
              lineHeight='short'
            >
              <Icon as={FaRegLightbulb} size='sm' mr={2} />
              {t('hero.tagline')}
            </Badge>
          }
          headline={t('hero.headline')}
          description={t('hero.description')}
          justifyContent='center'
        >
          <Stack direction={{ base: 'column', md: 'row' }} gap='3' pt={{ base: 4, md: 0 }}>
            <Button asChild size={{ base: 'lg', md: '2xl' }}>
              <NextLink href='/sign-up/'>{t('hero.startEInvoicing')}</NextLink>
            </Button>
            <Button asChild variant='outline' size={{ base: 'lg', md: '2xl' }} colorPalette='gray'>
              <NextLink href='/#contact-us'>{t('hero.getDemo')}</NextLink>
            </Button>
          </Stack>
        </HeroHeader>
        <Box position='relative' overflow='hidden'>
          <CircleAsset position='absolute' top='0' left='0' />
          <DotGridAsset position='absolute' bottom='0' right='0' />
          <motion.div
            initial={{ x: '100vw', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 60, damping: 15 }}
          >
            <Box p={{ base: 12, md: 16, lg: 20 }}>
              <Image
                src='/images/v2-hero.jpg'
                alt='eezi website'
                aspectRatio='1'
                width='full'
                borderRadius={{ base: '45px', md: '70px' }}
                position='relative'
              />
            </Box>
          </motion.div>
        </Box>
      </SimpleGrid>
    </Container>
  );
};
